module.exports = __webpack_public_path__ + "img/04-3-1高效.c2677b1e.svg";